
import { ToastContainer, toast } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';

function copyToClipboard(text) {
    //copyConfirm()
    const notify = () => toast("Copied!");
    notify()
    return navigator.clipboard.writeText(text);
  }
  export default copyToClipboard